import apiService from "@/services/ApiService";
import Helper from "@/common/helper";
import moment from "moment";
import storageKeys from "@/consts/storageKeys";

const api = new apiService();

export default {
  getCams({ commit }) {
    return new Promise((resolve, reject) => {
      api.getCams().then(
        cams => {
          commit(
            "setCams",
            cams.filter(cam => cam.status.enabled)
          );
          resolve();
        },
        e => {
          reject(e);
        }
      );
    });
  },
  getMaps({ commit }) {
    api.getMaps().then(maps => {
      return commit(
        "setMaps",
        maps.filter(({ enabled }) => enabled)
      );
    });
  },
  getMap({ commit }, { mapId, mapGroupId, mapName }) {
    return api.getMap(mapGroupId).then(mapGroup => {
      const requiredMap = Object.values(mapGroup.map).find(
        map => map.name === mapName
      );

      if (!requiredMap) {
        return;
      }

      return commit("updateMap", {
        mapId,
        mapGroupId,
        map: {
          ...Helper.transformMap(requiredMap, mapId, mapGroup)
        }
      });
    });
  },
  getMapImage({ commit, getters }, { mapGroupId, mapId, activeMap }) {
    let data = {
      mapGroupId,
      mapId
    };

    return new Promise((resolve, reject) => {
      if (activeMap.url !== null) {
        Helper.preloadImage(activeMap.url)
          .then(() => {
            commit("updateMap", {
              ...data,
              map: {
                image: activeMap.url,
                width: activeMap.width,
                height: activeMap.height
              }
            });

            resolve(activeMap.globalURL);
          })
          .catch(() => {
            commit("updateMap", {
              ...data,
              map: {
                image: false,
                width: activeMap.width || 1,
                height: activeMap.height || 1
              }
            });

            reject();
          });
        return;
      }

      api
        .getMapImage(mapGroupId, activeMap.imageId)
        .then(r => {
          Helper.preloadImage(r)
            .then(() => {
              commit("updateMap", {
                ...data,
                map: {
                  image: r,
                  width: activeMap.width,
                  height: activeMap.height
                }
              });

              resolve(r);
            })
            .catch(e => {
              console.dir(e);
              console.log(e.message);

              commit("updateMap", {
                ...data,
                map: {
                  image: false,
                  width: activeMap.width || 1,
                  height: activeMap.height || 1
                }
              });

              reject();
            });
        })
        .catch(e => {
          console.dir(e);
          console.log(e.message);

          commit("updateMap", {
            ...data,
            map: {
              image: false,
              width: activeMap.width || 1,
              height: activeMap.height || 1
            }
          });

          reject();
        });
    });
  },
  setGrid({ commit, state, getters }, grid) {
    let view = getters.getActiveView;

    commit("setGrid", grid);

    if (view) {
      commit("changeViewGrid", {
        grid: grid,
        viewId: view.id
      });
    }
  },
  getCamImage({ state }, camId) {
    let cam = state.cams[camId] || null;

    if (cam) {
      let lastImage = null;
      if (cam.image) {
        lastImage = cam.image;
      } else if (cam.lastImage) {
        lastImage = cam.lastImage;
      }

      state.cams[camId] = {
        ...state.cams[camId],
        lastImage,
        image: "loading"
      };

      api.getCamImage(cam.id).then(
        r => {
          const imageDate = moment()
            .locale(state.i18n.locale)
            .format("DD MMMM YYYY HH:mm:ss")
            .toLowerCase();

          state.cams[camId] = {
            ...state.cams[camId],
            imageDate,
            lastImage,
            image: r
          };
        },
        () => {
          state.cams[camId] = {
            ...state.cams[camId],
            lastImage,
            image: false
          };
        }
      );
    }
  },
  getAlarms({ commit, state }, { cams, params }) {
    commit("setAlarms", []);

    return new Promise((resolve, reject) => {
      api.getAlarms(cams, params).then(
        alarms => {
          commit("setAlarms", alarms);
          resolve(alarms);
        },
        () => {
          reject();
        }
      );
    });
  },
  getPage({ commit, state }, name) {
    return new Promise((resolve, reject) => {
      api.getPage(name).then(r => {
        resolve(r);
      });
    });
  },
  getObject(store, { type, id }) {
    return api.getAcsObject(type, id);
  },
  async setWsWebConnect({ commit, dispatch, getters }) {
    try {
      const res = await api.get("ws_auth");
      await new Promise((resolve, reject) => {
        const isSecure = window.location.protocol === "https:";

        const wsWebConnect = new WebSocket(
          `ws${isSecure ? "s" : ""}://${window.location.host}/ws/`
        );

        commit("setWsWebConnect", wsWebConnect);

        wsWebConnect.onmessage = async res => {
          const data = res.data ? JSON.parse(res.data) : null;
          const authError = new Error("Auth error");
          authError.status = 401;
          if (data) {
            switch (data.type) {
              case "auth success":
                dispatch("subscribeCamsState");
                resolve(wsWebConnect);
                break;
              case "state":
                if (data.data.type === "CAM") {
                  commit("changeCamState", data.data);
                } else {
                  commit("setObjectState", {
                    data: data.data,
                    getters
                  });
                }

                break;
              default:
                reject(authError);
            }
          }
        };
        wsWebConnect.onclose = () => {
          const token = localStorage.getItem(storageKeys.USER_TOKEN);

          if (token) {
            window.setTimeout(() => {
              dispatch("setWsWebConnect");
            }, 1000);
          }
        };

        wsWebConnect.onopen = () => {
          wsWebConnect.send(
            JSON.stringify({
              type: "auth",
              token: res.token
            })
          );
        };

        wsWebConnect.onerror = err => {
          if (wsWebConnect.readyState === 0) {
            reject(err);
          }
        };
      });
    } catch (e) {
      throw e;
    }
  },
  async subscribeCamsState({ state }) {
    state.wsWebConnect.send(
      JSON.stringify({
        type: "subscribe",
        data: {
          add_rules: [
            {
              type: "CAM",
              action: "STATE_CHANGED"
            }
          ]
        }
      })
    );
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js